import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../constants/path';
import { REDIRECT_SAV_CLIENT } from '../constants';
import { getI18nByApp } from '../services/i18n/selector';
import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import LinkButtonComponent from './button/LinkButtonComponent';

import { CustomerServiceContainer } from './CustomerServiceComponentStyle';

class CustomerServiceComponent extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <CustomerServiceContainer
                className={`${this.props.cssClass ? this.props.cssClass : ''}`}>
                <div className="titre">
                    {getI18nByApp(i18n, 'feature.aide.serviceclient.title')}
                </div>
                <div className="text">
                    <p>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'feature.aide.serviceclient.text1')
                        )}
                    </p>
                    <p>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'feature.aide.serviceclient.text2')
                        )}
                    </p>
                </div>
                {REDIRECT_SAV_CLIENT ? (
                    <a href={REDIRECT_SAV_CLIENT} target="_blank" className="bt bt-second">
                        {getI18nByApp(i18n, 'feature.aide.serviceclient.button')}
                    </a>
                ) : (
                    <LinkButtonComponent
                        to={PATH.CONTACTREQUEST_PATH}
                        text={getI18nByApp(i18n, 'feature.aide.serviceclient.button')}
                        title="Nous contacter"
                        color="second"
                    />
                )}
            </CustomerServiceContainer>
        );
    }
}

CustomerServiceComponent.propTypes = {
    cssClass: PropTypes.string,
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n
    };
};

export default connect(mapStateToProps)(CustomerServiceComponent);



// WEBPACK FOOTER //
// ./src/components/CustomerServiceComponent.js